module.exports = __webpack_public_path__ + "img/icon-pause--orange.5094d45d.svg";